import axios from 'axios';
import { message } from 'antd';
import {
  PRODUCT_TEMPLATES_API,
} from '../../../constants/API';
import {
  DELETE_PRODUCT_TEMPLATE_LOADING
} from '../types';
import getProductTemplates from './getProductTemplates';

function deleteProductTemplate(id) {
  return async(dispatch, getState) => {
      dispatch({
        type: DELETE_PRODUCT_TEMPLATE_LOADING,
        deletingProductTemplate: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        await axios.delete(`${PRODUCT_TEMPLATES_API}/${id}`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
        dispatch({
          type: DELETE_PRODUCT_TEMPLATE_LOADING,
          deletingProductTemplate: false
        });
        await dispatch(getProductTemplates());

      } catch (e) {
        message.error(String(e));
        dispatch({
          type: DELETE_PRODUCT_TEMPLATE_LOADING,
          deletingProductTemplate: false
        });
        console.log(e);
      }
  }
}
export default deleteProductTemplate;
